import { Overlay } from "@angular/cdk/overlay";
import { Injectable } from "@angular/core";
import { NzContextMenuService } from "ng-zorro-antd/dropdown";

@Injectable()
export class UiContextMenuService extends NzContextMenuService {
  constructor(overlay: Overlay) {
    super(overlay);
  }
}
